import { render, staticRenderFns } from "./onboarding.vue?vue&type=template&id=04f87bd6&scoped=true&"
import script from "./onboarding.vue?vue&type=script&lang=js&"
export * from "./onboarding.vue?vue&type=script&lang=js&"
import style0 from "./onboarding.vue?vue&type=style&index=0&id=04f87bd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f87bd6",
  null
  
)

component.options.__file = "onboarding.vue"
export default component.exports